const NS = 'HotspotBlock';
const CLS = 'hotspotBlock';

import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';
import { trackingItemsMixinBlock } from '../../mixins/trackingItemsMixinBlock/trackingItemsMixinBlock';
import { mediaQuery } from '../../../../global/js/wlc/mediaQuery';

export class HotspotBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$canvas = this.$element.find(`.${CLS}-canvas`);
		this.$image = this.$element.find(`.${CLS}-image`);
		this.$hotspots = this.$element.find(`.hotspotCoordinateBlock`);
		this.$hotspotColumnContent = this.$element.find(`.${CLS}-col--content`);
		this.$card = this.$element.find(`.${CLS}-card`);
		this.$cardTitle = this.$card.find(`.${CLS}-card-title`);
		this.$cardDescription = this.$card.find(`.${CLS}-card-description`);
		this.cardAnimationDuration = 400;
		this.cardAnimationCompleted = true;

		// Initial animation of card
		this.$card.hide();
		this.$card.css({
			opacity: 0
		});
		setTimeout(() => {
			this.$card.show();
		}, this.cardAnimationDuration);

		this.$activeHotspotBlock = null;
		this.$imageProperties = {
			ratio: {
				width: null,
				height: null
			}
		};

		this.setRatio();
		this.scaleImage();
		this.setHotspots();
		this.setHotspotClickEvent();
		this.setHotspotContentHeight();

		$(window).resize(_.debounce(() => {
			this.scaleImage();
			this.setHotspots();
			this.setHotspotContentHeight();
		}, 25));

		this.initFullWindowHeight(this);
		this.initTrackingItems(this, this.$hotspots);

		// Trigger this again
		setTimeout(() => {
			this.scaleImage();
			this.setHotspots();
			this.setHotspotContentHeight();
		}, 500);
	}

	setRatio() {
		this.$imageProperties.ratio.width = this.$image.width();
		this.$imageProperties.ratio.height = this.$image.height();
	}

	scaleImage() {
		let width = this.$canvas.width();

		this.$image.css({
			width: width,
			height: (width * (this.$imageProperties.ratio.height / this.$imageProperties.ratio.width)),
			visibility: 'visible'
		});
	}

	setHotspots() {
		this.$hotspots.each((index, element) => {
			let x = !_.isNil($(element).attr('data-x-percentage')) ? parseInt($(element).attr('data-x-percentage')) : null;
			let y = !_.isNil($(element).attr('data-y-percentage')) ? parseInt($(element).attr('data-y-percentage')) : null;

			if(_.isFinite(x) && x >= 0 && x <= 100) {
				if(_.isFinite(y) && y >= 0 && y <= 100) {
					$(element).css({
						left: `${Math.abs(x - 100)}%`,
						top: `${Math.abs(y - 100)}%`,
						display: 'inline-block',
						transform: 'translate3d(-50%, -50%, 0)'
					});
				}
				else {
					console.error(`${NS}::Error`, 'Please supply a valid y-percentage between 0–100');
				}
			}
			else {
				console.error(`${NS}::Error`, 'Please supply a valid x-percentage between 0–100');
			}
		});
	}

	setHotspotClickEvent() {
		// Clicking outside the hotspotCoordinateBlock
		$(document).on('click', (event) => {
			if(!$(event.target).hasClass('hotspotCoordinateBlock') && this.$activeHotspotBlock) {
				this.$activeHotspotBlock.removeClass('hotspotCoordinateBlock--active');
				this.$activeHotspotBlock.addClass('hotspotCoordinateBlock--done');
				this.$activeHotspotBlock = null;
			}
		});

		this.$hotspots.on('click', (event) => {
			let $element = $(event.currentTarget);

			if(this.cardAnimationCompleted) {
				let deactivate = () => {
					this.cardAnimationCompleted = false;

					this.$activeHotspotBlock.removeClass('hotspotCoordinateBlock--active');
					this.$activeHotspotBlock.addClass('hotspotCoordinateBlock--done');
					this.$activeHotspotBlock = null;

					this.$card.css({
						opacity: 0
					});

					setTimeout(() => {
						this.$cardTitle.html('');
						this.$cardDescription.html('');
						this.cardAnimationCompleted = true;
					}, this.cardAnimationDuration);
				};

				let activate = ($elementToActivate) => {
					this.cardAnimationCompleted = false;

					this.$activeHotspotBlock = $elementToActivate;
					this.$activeHotspotBlock.addClass('hotspotCoordinateBlock--active');
					let title = this.$activeHotspotBlock.data('title');
					let description = this.$activeHotspotBlock.data('description');
					this.$cardTitle.html(title);
					this.$cardDescription.html(description);
					this.$card.css({
						opacity: 1
					});

					setTimeout(() => {
						this.cardAnimationCompleted = true;
					}, this.cardAnimationDuration);
				};

				if(!this.$activeHotspotBlock) {
					activate($element);
				}
				else if(this.$activeHotspotBlock.is($element)) {
					deactivate();
				}
				else {
					deactivate();
					setTimeout(() => {
						activate($element);
					}, this.cardAnimationDuration);
				}
			}
		});
	}

	setHotspotContentHeight() {
		if(!mediaQuery.breakpointMaxWidth(mediaQuery.BREAKPOINTS.LG)) {
			this.$hotspotColumnContent.css({
				minHeight: this.$image.height()
			});
		}
		else {
			this.$hotspotColumnContent.css({
				minHeight: 'unset'
			});
		}
	}
}

Object.assign(HotspotBlock.prototype, fullWindowHeightMixinBlock);
Object.assign(HotspotBlock.prototype, trackingItemsMixinBlock);
